import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UsersIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  ArrowPathIcon,
  ChartBarIcon,
  DocumentChartBarIcon,
  Cog6ToothIcon,
  UserGroupIcon,
  BuildingOfficeIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import agencyService from '../../services/agencyService';
import tenantService from '../../services/tenantService';
const navigation = [
  { name: 'Tableau de bord', href: '/', icon: HomeIcon },
  { name: 'Clients', href: '/clients', icon: UsersIcon },
  { name: 'Comptes Épargne', href: '/accounts', icon: CreditCardIcon },
  { name: 'Prêts', href: '/loans', icon: CurrencyDollarIcon },
  { name: 'Remboursements', href: '/repayments', icon: ArrowPathIcon },
  { name: 'Agences', href: '/agencies', icon: BuildingOfficeIcon },
// Dans votre Sidebar.js, ajoutez ces éléments :
  { name: 'Tableau de bord TENANT', href: '/tenant/dashboard', icon: ChartBarIcon },
  { name: 'Paramètres Tenant', href: '/tenant/settings', icon: Cog6ToothIcon },
  { name: 'Utilisateurs', href: '/users', icon: UserGroupIcon },
  { name: 'Rapports', href: '/reports', icon: DocumentChartBarIcon },
  { name: 'Analytiques', href: '/analytics', icon: ChartBarIcon },
  { name: 'Paramètres', href: '/settings', icon: Cog6ToothIcon },
];

const Sidebar = () => {
  const location = useLocation();
  const { hasPermission ,user} = useAuth();
 // const { user, logout } = useAuth();
 const [agencyData, setAgencyData] = useState(null);
  const [tenantData, setTenantData] = useState(null);
  const filteredNavigation = navigation.filter(item => {
    if (item.name === 'Agences' && !hasPermission('manage_agencies')) return false;
    if (item.name === 'Utilisateurs' && !hasPermission('manage_users')) return false;
    return true;
  });
////////////////////////////////
useEffect(() => {
    fetchAgency(user.agency_id);
  }, []);

 const fetchAgency = async (id) => {
    try {
      const data = await agencyService.getAgency(id);
       const [agData, tenantData] = await Promise.all([
               agencyService.getAgency(id),
               tenantService.getCurrentTenant()
            ]);
      setAgencyData(agData);
      setTenantData(tenantData);
      // Set form values
    } catch (error) {
     // showError('Erreur lors du chargement du client');
  
    } finally {
    }
  };
////////////////////////////
  return (
    <div className="flex flex-col flex-1 bg-gray-800">
      <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
        <div className="flex items-center flex-shrink-0 px-4">
          <div className="flex items-center">
            <CurrencyDollarIcon className="h-8 w-8 text-white" />
            <span className="ml-2 text-white text-xl font-bold">{tenantData?tenantData.name:''} - {agencyData? agencyData.name:''}</span>
          </div>
        </div>
        <nav className="mt-5 flex-1 px-2 space-y-1">
          {filteredNavigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <NavLink
                key={item.name}
                to={item.href}
                className={`
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md
                  ${isActive
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }
                `}
              >
                <item.icon
                  className={`
                    mr-3 flex-shrink-0 h-6 w-6
                    ${isActive ? 'text-white' : 'text-gray-400 group-hover:text-white'}
                  `}
                  aria-hidden="true"
                />
                {item.name}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;